import axios from 'axios'

const BASE_URL = `${process.env.VUE_APP_baseUrl}/api/payment-sous-traitance`

export default {
  namespaced: true,

  state: {
    payments: [],
    payment: null,
    availableOrders: [],
    outsourcingCompanies: [],
    pagination: {
      count: 0,
      next: null,
      previous: null,
    },
    totalCodAmount: 0,
    isLoading: false,
    error: null,
  },

  mutations: {
    SET_PAYMENTS(state, {
      results,
      count,
      next,
      previous,
      totalCodAmount,
    }) {
      state.payments = results
      state.pagination = { count, next, previous }
      state.totalCodAmount = totalCodAmount || 0
    },
    SET_PAYMENT(state, payment) {
      state.payment = payment
    },
    SET_AVAILABLE_ORDERS(state, {
      results,
      count,
      next,
      previous,
    }) {
      state.availableOrders = results
      state.pagination = { count, next, previous }
    },
    SET_OUTSOURCING_COMPANIES(state, companies) {
      state.outsourcingCompanies = companies
    },
    SET_LOADING(state, val) {
      state.isLoading = val
    },
    SET_ERROR(state, err) {
      state.error = err
    },
  },

  actions: {
    async fetchPayments({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/`, { params })
        commit('SET_PAYMENTS', {
          results: data.results || data,
          count: data.count || 0,
          next: data.next || null,
          previous: data.previous || null,
          totalCodAmount: data.total_cod_amount || 0,
        })
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchPayment({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/${id}/`)
        commit('SET_PAYMENT', data)
        return data
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createPayment(_, payload) {
      const { data } = await axios.post(`${BASE_URL}/create/`, payload)
      return data
    },

    async validatePayment({ commit }, id) {
      const { data } = await axios.post(`${BASE_URL}/${id}/validate/`)
      commit('SET_PAYMENT', data)
      return data
    },

    async fetchAvailableOrders({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get(`${BASE_URL}/available-orders/`, { params })
        commit('SET_AVAILABLE_ORDERS', {
          results: data.results || data,
          count: data.count || 0,
          next: data.next || null,
          previous: data.previous || null,
        })
      } catch (err) {
        commit('SET_ERROR', err)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchOutsourcingCompanies({ commit }) {
      const { data } = await axios.get(`${BASE_URL}/outsourcing-companies/`)
      commit('SET_OUTSOURCING_COMPANIES', data.results || data)
      return data.results || data
    },
  },

  getters: {
    payments: s => s.payments,
    payment: s => s.payment,
    availableOrders: s => s.availableOrders,
    outsourcingCompanies: s => s.outsourcingCompanies,
    isLoading: s => s.isLoading,
    pagination: s => s.pagination,
    totalCodAmount: s => s.totalCodAmount,
  },
}
